import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor() {}

  ngOnInit() {
    this.redirectLegacyHashUrls();
    // Keycloak callback handling is performed by keycloak-js during app initialization.
  }

  private redirectLegacyHashUrls(): void {
    const hash = window.location.hash || '';
    if (!hash.startsWith('#/')) {
      return;
    }

    const hashRoute = hash.slice(1); // '/path?query'
    const [routePath, routeQuery] = hashRoute.split('?');

    const pathname = window.location.pathname;
    const localePrefixMatch = pathname.match(/^\/(en|en-US|bn|bn-BN)$/);
    const localePrefix = localePrefixMatch ? localePrefixMatch[0] : '';

    const normalizedPath = `${localePrefix}${routePath}`.replace(/\/{2,}/g, '/');
    const queryString = routeQuery ? `?${routeQuery}` : '';
    const migratedUrl = `${window.location.origin}${normalizedPath}${queryString}`;

    window.location.replace(migratedUrl);
  }

}
